<template>
  <div class="fill-height">
    <!-- Основной контент -->
    <router-view @openDialog="openDialog" @closeDialog="closeDialog" />

    <!--Вторая левая панель-->
    <v-navigation-drawer
      v-if="!['sm', 'xs'].includes($vuetify.breakpoint.name)"
      v-model="secondPanelLeftDrawer"
      :width="secondPanelLeftWidth"
      :style="{
        'margin-left': (secondPanelLeftDrawer ? panelLeftWidth : 0) + 'px'
      }"
      class="content-bg--1"
      disable-resize-watcher
      touchless
      fixed
    >
      <div class="fill-height" v-bar>
        <div class="fill-height">
          <div class="pl-5 py-4 pr-4">
            <v-flex text-xs-right>
              <button @click="closeSecondPanel" class="link text-xs-right">
                <icon-close></icon-close>
              </button>
            </v-flex>
            <support-form
              v-if="secondPanelComponent === 'supportForm'"
              @closeSecondPanel="closeSecondPanel"
              class="pr-2"
            ></support-form>
            <user-profile
              v-if="secondPanelComponent === 'userProfile'"
              @closeSecondPanel="closeSecondPanel"
              class="pr-2"
            ></user-profile>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- Левая панель-->
    <v-navigation-drawer
      v-model="panelLeftDrawer"
      :width="panelLeftWidth"
      class="panel-left"
      :touchless="!['md', 'sm', 'xs'].includes($vuetify.breakpoint.name)"
      app
      floating
    >
      <!--Оборачиваем в красивый scrollbar-->
      <div class="fill-height" v-bar>
        <div class="fill-height">
          <v-layout column fill-height justify-space-between>
            <navigation-left
              @openSecondPanel="openSecondPanel"
            ></navigation-left>

            <div
              v-if="!['sm', 'xs'].includes($vuetify.breakpoint.name)"
              class="panel-left__footer"
            >
              <v-btn
                @click="setTheme"
                :color="themeDark ? 'secondary' : 'white'"
                class="mx-0 text--secondary"
                depressed
              >
                <span v-if="!themeDark">
                  <icon-moon class="mr-2"></icon-moon> <span>Темная тема</span>
                </span>
                <span v-if="themeDark">
                  <icon-sun class="mr-2"></icon-sun> <span>Светлая тема</span>
                </span>
              </v-btn>
              <div
                :class="{
                  active:
                    secondPanelLeftDrawer &&
                    secondPanelComponent === 'userProfile'
                }"
                class="pt-3 pb-4 mb-4 font-weight-medium link"
                @click="openSecondPanel('userProfile')"
              >
                <icon-profile-circle
                  :color="
                    secondPanelLeftDrawer &&
                    secondPanelComponent === 'userProfile'
                      ? $vuetify.theme.primary
                      : $vuetify.theme.textPrimary
                  "
                  class="mr-2"
                >
                </icon-profile-circle>
                <span class="valign-middle">
                  {{ $store.getters.user.lastname }}
                </span>
              </div>
            </div>
          </v-layout>
        </div>
      </div>
    </v-navigation-drawer>

    <!--всплывашка с сообщениями при изменении данных-->
    <v-snackbar
      v-model="popupInfoActive"
      :timeout="$store.getters.popupInfoTimeout"
      :top="!['xs'].includes($vuetify.breakpoint.name)"
      right
    >
      <v-layout
        class=""
        :class="{
          'error text--white': $store.getters.popupType === 'error',
          'content-bg--1 text--primary': $store.getters.popupType === 'info'
        }"
        align-center
        pa-3
      >
        <div class="mr-3">
          <icon-info
            :color="
              $store.getters.popupType === 'error'
                ? 'white'
                : this.$vuetify.theme.textPrimary
            "
          ></icon-info>
        </div>
        <div class="font-weight-medium">
          {{ $store.getters.popupInfoText }}
          <div
            v-if="$store.getters.popupInfoAction"
            @click="popupAction"
            class="link font-weight-medium pt-2"
          >
            {{ $store.getters.popupInfoAction.name }}
          </div>
        </div>
      </v-layout>

      <v-btn @click="popupInfoActive = false" class="btn-close" icon absolute>
        <icon-close
          :color="
            $store.getters.popupType === 'error'
              ? 'white'
              : this.$vuetify.theme.textPrimary
          "
        ></icon-close>
      </v-btn>
    </v-snackbar>
    <v-dialog
      v-model="dialogDrawer"
      :width="dialogWidth"
      scrollable
      persistent
      :fullscreen="dialogFullScreen"
    >
      <v-flex v-bar>
        <div>
          <v-btn
            @click="dialogDrawer = false"
            icon
            small
            absolute
            class="v-dialog__btn-close"
          >
            <icon-close></icon-close>
          </v-btn>
          <div :class="`${dialogSpace ? 'pr-2' : ''}`">
            <div :class="`${dialogSpace ? 'pa-md-4 ma-md-3 pa-3' : ''}`">
              <hotspot-order
                v-if="dialogDrawer && dialogComponent === 'hotspotOrder'"
                @closeDialog="closeDialog"
              ></hotspot-order>

              <hotspot-edit-wifi
                v-if="dialogDrawer && dialogComponent === 'hotspotEditWifi'"
                @closeDialog="closeDialog"
                :id="dialogParams.id"
                :param="dialogParams.param"
              ></hotspot-edit-wifi>

              <hotspot-edit-name
                v-if="dialogDrawer && dialogComponent === 'hotspotEditName'"
                @closeDialog="closeDialog"
                :id="dialogParams.id"
              ></hotspot-edit-name>

              <templates-statistics-edit
                v-if="
                  dialogDrawer && dialogComponent === 'templatesStatisticsEdit'
                "
                @closeDialog="closeDialog"
                :param="dialogParams.param"
              ></templates-statistics-edit>

              <sms-mailing-form
                v-if="dialogDrawer && dialogComponent === 'smsMailingForm'"
                @closeDialog="closeDialog"
                :param="dialogParams.param"
              ></sms-mailing-form>

              <tariff-v-window
                v-if="dialogDrawer && dialogComponent === 'tariffVWindow'"
                @closeDialog="closeDialog"
                :params="dialogParams.params"
              ></tariff-v-window>

              <tariff-function-change-confirm
                v-if="
                  dialogDrawer &&
                    dialogComponent === 'tariffFunctionChangeConfirm'
                "
                @closeDialog="closeDialog"
                :funcId="dialogParams.funcId"
                :tarifId="dialogParams.tarifId"
                :serviceId="dialogParams.serviceId"
              ></tariff-function-change-confirm>
            </div>
          </div>
        </div>
      </v-flex>
    </v-dialog>

    <!--Диалоговое окно для увеличения изображений-->
    <v-dialog
      v-model="dialogImgDrawer"
      max-width="1000"
      content-class="v-dialog-img"
    >
      <img class="img-fluid" :src="dialogParams.src" />
    </v-dialog>
  </div>
</template>

<script>
import NavigationLeft from "../components/navigation/NavigationLeft.vue";
import IconMoon from "../components/icon/IconMoon.vue";
import IconSun from "../components/icon/IconSun.vue";
import IconInfo from "../components/icon/IconInfo.vue";
import IconClose from "../components/icon/IconClose.vue";
import UserProfile from "../components/user/UserProfile.vue";
import IconProfileCircle from "../components/icon/IconProfileCircle.vue";
import SupportForm from "../components/support/SupportForm.vue";
import HotspotOrder from "../components/hotspot/HotspotOrder.vue";
import HotspotEditWifi from "../components/hotspot/HotspotEditWifi.vue";
import HotspotEditName from "../components/hotspot/HotspotEditName.vue";
import TemplatesStatisticsEdit from "../components/template/TemplatesStatisticsEdit.vue";
import SmsMailingForm from "../components/sms/SmsMailingForm.vue";
import TariffVWindow from "../components/tariff/TariffVWindow.vue";
import TariffFunctionChangeConfirm from "../components/tariff/TariffFunctionChangeConfirm.vue";
import Common from "../modules/common";

export default {
  name: "HomeView",

  components: {
    HotspotEditName,
    HotspotEditWifi,
    HotspotOrder,
    SupportForm,
    IconProfileCircle,
    UserProfile,
    IconSun,
    IconMoon,
    IconClose,
    IconInfo,
    NavigationLeft,
    TemplatesStatisticsEdit,
    SmsMailingForm,
    TariffVWindow,
    TariffFunctionChangeConfirm
  },

  data: () => ({
    // ширина основной левой панели
    panelLeftWidth: 250,
    // открыть/закрыть вторую левую панель
    secondPanelLeftDrawer: false,
    // компонент который активизируем во второй левой панели
    secondPanelComponent: false,
    // ширина второй левой панели
    secondPanelLeftWidth: 400,
    // параметры диалогового окна
    dialogParams: {},
    // компонент который активизируем в диалоговом окне
    dialogComponent: false,
    // открыть/закрыть диалоговое окно с изображением
    dialogImgDrawer: false,
    // открыть/закрыть диалоговое окно
    dialogDrawer: false
  }),

  computed: {
    // цветовая тема проекта
    themeDark: {
      get: function() {
        return this.$store.getters.themeDark;
      },
      set: function(value) {
        this.$store.commit("SET_THEME_DARK", value);
      }
    },
    // состояние левой панели
    panelLeftDrawer: {
      get: function() {
        return this.$store.getters.panelLeftDrawer;
      },
      set: function(val) {
        this.$store.commit("SET_PANEL_LEFT_DRAWER", val);
      }
    },
    // состояние всплывашки с сообщениями
    popupInfoActive: {
      get: function() {
        return this.$store.getters.popupInfoActive;
      },
      set: function() {
        this.$store.commit("CLEAR_POPUP_INFO");
      }
    },
    // текущий роут
    routeName() {
      return this.$route.name;
    },
    // параметры диологового окна
    // с отступами/без отступов
    dialogSpace() {
      return this.dialogParams.dialogSpace === false
        ? this.dialogParams.dialogSpace
        : true;
    },
    // ширина окна
    dialogWidth() {
      return this.dialogParams.dialogWidth
        ? this.dialogParams.dialogWidth
        : 400;
    },
    // fullscreen
    dialogFullScreen() {
      return this.dialogParams.dialogFullScreen
        ? this.dialogParams.dialogFullScreen
        : false;
    }
  },

  watch: {
    routeName() {
      // закрываем всплывашки при смене роута
      this.secondPanelLeftDrawer = false;
      this.dialogDrawer = false;
    }
  },

  methods: {
    /**
     * открывает левую доп. панель
     * @param component - компонент внутри панели
     */
    openSecondPanel(component) {
      // если открыт другой компонент
      if (
        this.secondPanelLeftDrawer &&
        this.secondPanelComponent !== component
      ) {
        this.secondPanelLeftDrawer = false;
      }
      setTimeout(() => {
        this.secondPanelComponent = component;
        this.secondPanelLeftDrawer = !this.secondPanelLeftDrawer;
      }, 100);
    },

    /**
     * закрывает левую доп. панель
     */
    closeSecondPanel() {
      console.log("closeSecondPanel");
      this.secondPanelComponent = null;
      this.secondPanelLeftDrawer = false;
    },

    /**
     * открывает диалоговое окно
     * @param params: {component: компонент внутри}
     */
    openDialog(params) {
      this.dialogParams = params;
      if (params.type === "img") {
        this.dialogImgDrawer = true;
      } else {
        // если открыт другой компонент
        if (this.dialogDrawer && this.dialogComponent !== params.component) {
          this.dialogDrawer = false;
        }
        setTimeout(() => {
          this.dialogComponent = params.component;
          this.dialogDrawer = !this.dialogDrawer;
        }, 100);
      }
    },
    /**
     * закрывает диалоговое окно
     */
    closeDialog() {
      this.dialogComponent = false;
      this.dialogDrawer = false;
    },
    /**
     * Меняет тему
     * Отправляет событие в метрику
     */
    setTheme() {
      this.themeDark = !this.themeDark;
      Common.sendMetrika("theme_daynight");
    },
    popupAction() {
      // топаем в метод из стор, который мы передали в качестве параметров во всплывашку
      const textThen = this.$store.getters.popupInfoAction.textThen;
      this.$store
        .dispatch(
          this.$store.getters.popupInfoAction.method,
          this.$store.getters.popupInfoAction.param
        )
        .then(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: textThen
          });
        });
      this.popupInfoActive = false;
    }
  }
};
</script>
